<div class="mobi-videomessage">
  <div class="mobi-ui-grid is-centered mobi-ui-margin-t-md">
    <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4 !mb-0">
      <mobi-hero-text [title]="entity().title" [fullWidth]="true" />
    </div>
  </div>
  <div class="is-background page-content !mt-0">
    <mobi-content-section class="video-content" [content]="videoContent">
      <ng-template #videoContent>
        <a
          [betterRouterLink]="entity().person.url | extractUrl"
          class="mobi-ui-flex items-center mobi-ui-margin-b-xxl text-black"
        >
          @if (entity().person.image) {
            <div class="person-image person-image-spacing">
              @defer (hydrate never) {
                <mobi-media [entity]="entity().person.image" />
              }
            </div>
          } @else {
            <div class="person-image person-image-spacing">
              <img
                src="/placeholders/profile_picture_placeholder_large.svg"
                alt="person palceholder image"
              />
            </div>
          }
          <div class="mobi-ui-font-size-200">
            <div class="mobi-ui-font-bold">
              {{ entity().person.firstName }} {{ entity().person.lastName }}
            </div>
            <div>{{ entity().person.functionTaxonomy?.label }}</div>
            @if (
              entity().person?.locationActivity?.length &&
              entity().person.locationActivity[0].location?.generalAgency?.title
            ) {
              <span>
                {{ entity().person.locationActivity[0].location?.generalAgency?.title }}
              </span>
            }
          </div>
        </a>
        @defer (hydrate on viewport) {
          <mobi-media
            class="block"
            [entity]="{
              type: 'MediaRemoteVideo',
              embedUrl: entity().video.value,
              uuid: 'video-' + entity().uuid,
            }"
          />
        }
      </ng-template>
    </mobi-content-section>
    @if (entity()?.form?.id) {
      <mobi-content-section [content]="content" width="lg">
        <ng-template #content>
          <mobi-webform [webformId]="entity().form.id" [isParagraph]="true" />
        </ng-template>
      </mobi-content-section>
    }
    @if (hasLocation() && entity().person.locationActivity[0].location?.generalAgency) {
      <mobi-content-section [content]="map">
        <ng-template #map>
          <div class="mobi-ui-flex tems-center">
            @if (entity().person.locationActivity[0].location.generalAgency?.title) {
              <h2 class="mobi-ui-margin-r-lg !p-0">
                {{ entity().person.locationActivity[0].location.generalAgency?.title }}
              </h2>
            }
            @if (entity().person.locationActivity[0].location.generalAgency?.url) {
              <a
                [betterRouterLink]="
                  entity().person.locationActivity[0].location.generalAgency?.url
                    | extractUrl
                "
                aria-label="Go to General Agency page"
                class="mobi-ui-btn-icon-minor is-small mobi-ui-animation-trigger-hover"
              >
                <mobi-ui-icon-major
                  name="right"
                  class="mobi-ui-ink-grey mobi-ui-animation-horizontal-wiggle-hover-target"
                />
              </a>
            }
          </div>
          @defer (hydrate on viewport) {
            <mobi-map-small
              class="mobi-ui-width-full"
              [agency]="entity().person.locationActivity[0].location.generalAgency!.title"
              [location]="$any(entity().person.locationActivity[0]?.location)"
            />
          }
        </ng-template>
      </mobi-content-section>
    }
  </div>
</div>
